import React from "react";
import "./StockIcon.scss";
import { placeholderStock } from "../../assets/images/icons";
import { ImageComp } from "../Image/image";
import parse from "html-react-parser";
export const generateStockIconUrl = ppRefId => {
  if (process.env.GATSBY_CUBE_ASSETS_PUBLIC_PATH)
    return `${process.env.GATSBY_CUBE_ASSETS_PUBLIC_PATH}/instrument/icon/${ppRefId}`;
  else throw new Error("ERROR_GENRATING_STOCK_ICON_URL");
};

export const StockIcon = ({ ppRefId, className = "" }) => {
  try {
    const url = generateStockIconUrl(ppRefId);
    return (
      <div className={"icon-container"}>
        <ImageComp
          className={className}
          url={url}
          placeholderComp={parse(placeholderStock)}
        />
      </div>
    );
  } catch {
    return parse(placeholderStock);
  }
};
